OT.createNS('OT.Common.Viewport');

OT.Common.Viewport = (function () {
    'use strict';

    var winWidthBreak = 768;
    var userAgent = window.navigator.userAgent.toLowerCase();

    var isIpadVerticalOrSmaller = function () {
        if (getViewport().width <= winWidthBreak) {
            return true;
        } else {
            return false;
        }
    };

    var isIpadVerticalOrBigger = function () {
        if (getViewport().width >= winWidthBreak) {
            return true;
        } else {
            return false;
        }
    };

    $(function() {
        var $body = $('body');

        // If we're looking at an Android device we need to differentiate Phone from Tablet on the client
        if (!$body.hasClass('platform-android')) {
            return;
        }

        if (isTabletDimensions()) {
            $body.addClass('device-tablet');
        } else if (isPhoneDimensions()) {
            $body.addClass('device-phone');
        }
    })

    var isTablet = function() {
        var $body = $('body');
        if ($body.hasClass('device-tablet')) {
            return true;
        }

        // TODO: This is redundant with our android checker above, can we remove?
        if ($body.hasClass('platform-android') && isTabletDimensions()) {
            return true;
        }

        return false;
    };

    function isTabletDimensions() {
        return window.matchMedia && window.matchMedia("screen and (min-width: 425px) and (max-width: 770px)").matches;
    }

    var isPhone = function() {
        var $body = $('body');
        if ($body.hasClass('device-phone')) {
            return true;
        }

        // TODO: This is redundant with our android checker above, can we remove?
        if ($body.hasClass('platform-android') && isPhoneDimensions()) {
            return true;
        }

        return false;
    };

    function isPhoneDimensions() {
        return window.matchMedia && window.matchMedia("screen and (max-width: 424px)").matches;
    }

    var isMobileDevice = function() {
        return isPhone() || isTablet();
    };

    // JC 20/11/14: $(window).width does not return the same width as a media query break point as it does not take into account the scrollbar
    // This causes layout issues where the map height will change with JS before the CSS alters its position
    // This function gives a consistent width to the media query, taken from http://stackoverflow.com/a/11310353/310174
    var getViewport = function() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    };

    return {
        isIpadVerticalOrSmaller: isIpadVerticalOrSmaller,
        isIpadVerticalOrBigger: isIpadVerticalOrBigger,
        isTablet: isTablet,
        isPhone: isPhone,
        isMobileDevice: isMobileDevice,
        getViewport: getViewport
    };

})();
